import React from 'react';
import { StyledCardWrapper, StyledCloudImage, StyledContentWrapper, StyledTextPairing } from './CheckOutExperienceCard.styles';
import { useTranslation } from 'react-i18next';

export const CheckOutExperienceCard = () => {
  const { t } = useTranslation('registry');
  const checkOutExperienceCard = t('guestExperienceSection.checkOutExperienceCard');

  return (
    <StyledCardWrapper>
      <StyledCloudImage
        alt={checkOutExperienceCard.imageAlt}
        optimization="none"
        src={'registry-q12024/better-for-guests/hero-seamlesscheckout@2x.png'}
      />

      <StyledContentWrapper>
        <StyledTextPairing
          titleVariant="calloutHed40"
          titleColor="white"
          titleTagName="h3"
          title={checkOutExperienceCard.title}
          body={checkOutExperienceCard.body}
          bodyVariant="dek20"
          bodyColor="white"
          bodyMaxWidth="480px"
          textAlign="center"
        />
      </StyledContentWrapper>
    </StyledCardWrapper>
  );
};
